// 权限

import router, { whiteList } from "../router";

import { getToken, setToken } from "@/utils/localToken.js";
import { exchangeLoginTicket } from "@/api/home";

const AUTH_QUERY = ["token", "hasMobile", "loginTicket"];

function isHomePath(path) {
  return path === "/home" || path === "/home/";
}

function stripAuthQuery() {
  const url = new URL(location.href);
  const ticket = url.searchParams.get("loginTicket");
  const needBindMobile = url.searchParams.get("hasMobile") === "false";
  const keys = isHomePath(url.pathname) ? AUTH_QUERY.concat("code") : AUTH_QUERY;
  const hadSensitive = keys.some((key) => url.searchParams.has(key));
  if (hadSensitive) {
    keys.forEach((key) => url.searchParams.delete(key));
    const path = needBindMobile ? "/login" : url.pathname;
    history.replaceState(history.state, "", path + url.search + url.hash);
  }
  return ticket;
}

const loginTicket = stripAuthQuery();
const authReady = (async () => {
  if (!loginTicket) {
    return;
  }
  try {
    const res = await exchangeLoginTicket(loginTicket);
    if (res && res.code === 200 && res.content && res.content.token) {
      setToken(res.content.token);
    }
  } catch (e) {
    console.info(e);
  }
})();

router.beforeEach(async (to, from, next) => {
  await authReady;
  const stripCode = isHomePath(to.path);
  if (to.query.token || to.query.hasMobile || to.query.loginTicket || (stripCode && to.query.code)) {
    const query = { ...to.query };
    const needBindMobile = query.hasMobile === "false";
    AUTH_QUERY.forEach((key) => {
      delete query[key];
    });
    if (stripCode) {
      delete query.code;
    }
    if (needBindMobile && to.path !== "/login") {
      next({ path: "/login", query, replace: true });
    } else {
      next({ path: to.path, query, replace: true });
    }
    return;
  }
  if (!getToken()) {
    if (whiteList.includes(to.path)) {
      next();
    } else {
      if (to.path === "/formPage" || to.path === "/phoneCodeLogin") {
        next();
      } else {
        next("/login");
      }
    }
  } else {
    console.log('getToken is null')
    if (to.path === "/login") {
      //next("/home");
    } else {
      next();
    }
  }
  if (from.query.title === "项目详情") {
    to.query.forceRefresh = true;
  }else{
    next()
  }
});
